<template>
  <footer
    class="show-more"
    v-show="itemsShowed < itemsTotal"
  >
    <p class="show-more-catalog-counter">
      Показано <span>{{ itemsShowed }}</span>
      из <span itemprop="numberOfItems">{{ itemsTotal }}</span>
      {{ (itemsTotal % 10 === 1) ? 'изделия' : 'изделий' }}
    </p>
    <p
      class="show-more-button-wrapper"
      v-if="itemsShowed < itemsTotal"
    >
      <a
        class="show-more-button"
        v-bind:href="nextPagePath"
        v-on:click.prevent="showMore()"
      >
        Показать больше
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'CatalogFooter',
  props: {
    itemsShowed: { type: Number },
    itemsTotal: { type: Number },
    page: { type: Number }
  },
  data: function () {
    return {}
  },
  computed: {
    nextPagePath: function () {
      return this.$router.resolve({
        name: 'CatalogCategoryPage',
        params: Object.assign({}, this.$route.params, {page: this.page + 1})
      }).href
    }
  },
  methods: {
    updatePageParam: function (page) {
      this.$router.push({
        params: Object.assign({}, this.$route.params, {page: page})
      })
      this.$route.meta.showMore = true
    },
    showMore: function () {
      this.updatePageParam(this.page + 1)
      this.$emit('catalog-show-more')
    }
  }
}
</script>

<style lang="scss" scoped="">
  .show-more {
    @include media ("<=tablet") {
      padding-top: 1.5em;
    };
    & > p {
      line-height: normal;
    }
    & > .show-more-catalog-counter {
      margin-bottom: 1.5em;
    }
    & > .show-more-button-wrapper {
      margin-bottom: 0;
      & > .show-more-button {
        cursor: pointer;
        @include framed-color-reversible-button()
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/CatalogFooter.vue